'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay');
const get = require('lodash.get');

const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');

const Callout = require('../../../components/Callout/Callout');
const CalloutStore = require('../../../components/Callout/CalloutStore');
const calloutHelper = require('../../../components/Callout/calloutHelper');

const { title, copy, cta, calloutCopy } = require('./DetailsInvoice.json');
const styles = require('./DetailsInvoice.scss');
const { trackGaEvent } = require('../../helpers/pdpTracking');
const ViewInvoiceLink = require('../Invoice/ViewInvoiceLink');

const trackClick = () => {
    trackGaEvent('product', 'view invoice', 'pdp description', 0);
};

const DetailsInvoice = ({ hasUserId, userId, user, itemId, viewer, callout, isPrintPage }) => {
    let shouldShowLink = false;

    if (
        !isPrintPage &&
        !get(viewer, 'item.isSold') &&
        get(viewer, 'item.isAvailable') &&
        get(user, 'canSeeInvoice') &&
        !get(viewer, 'transactions.totalResults')
    ) {
        shouldShowLink = true;
    }

    return shouldShowLink ? (
        <div className={`pdp-shipping-entry-content-container ${styles.wrapper}`}>
            <div className="pdp-details-entry-title-container">
                <span className="pdp-shipping-entry-title">{title}</span>
            </div>
            <div className="pdp-shipping-entry">
                {copy}
            </div>
            <div className={`return-modal-link js-invoice-link ${styles.returnModalLink}`} data-tn="return-modal-link">
                <ViewInvoiceLink
                    hasUserId={hasUserId}
                    userId={userId}
                    itemId={itemId}
                    viewer={viewer}
                    user={user}
                    onClick={trackClick}
                >
                    {cta}
                </ViewInvoiceLink>
                <Callout type={calloutHelper.CALLOUT_TYPE_VIEW_INVOICE}
                    copy={calloutCopy}
                    direction="bottom"
                    lockDirection
                    localCss={styles}
                    callout={callout}
                />
            </div>
        </div>
    ) : null;
};

DetailsInvoice.defaultProps = {
    isPrintPage: false
};

DetailsInvoice.propTypes = {
    hasUserId: PropTypes.bool.isRequired,
    isPrintPage: PropTypes.bool,
    itemId: PropTypes.string.isRequired,
    userId: PropTypes.string,
    viewer: PropTypes.object.isRequired,
    user: PropTypes.object,
    callout: PropTypes.object
};

module.exports = Relay.createContainer(provideContext(connectToStores(
    DetailsInvoice,
    [CalloutStore],
    context => {
        const calloutStore = context.getStore(CalloutStore);
        return ({callout: calloutStore.getCalloutData()});
    }
)), {
    initialVariables: {
        hasUserId: false,
        userId: null,
        itemId: null
    },
    fragments: {
        user: ({hasUserId, userId, itemId}) => Relay.QL`
            fragment on User {
                ${ViewInvoiceLink.getFragment('user', {hasUserId, userId, itemId})}
                canSeeInvoice: hasPermission(name: "B_INVOICE")
            }
        `,
        viewer: ({hasUserId, userId, itemId}) => Relay.QL`
            fragment on Viewer {
                ${ViewInvoiceLink.getFragment('viewer', {hasUserId, userId, itemId})}
                transactions(viewName: "buyer.buyerPreInvoiceFilter", buyerId: $userId, itemId: $itemId) @include(if: $hasUserId) {
                    totalResults
                }
                item(itemId: $itemId) {
                    isSold
                    isAvailable
                }
            }
        `
    }
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/DetailsInvoice.jsx